export default __webpack_public_path__ + "static/media/jal mahal1.d2751043.jpg";